import { frontendURL } from 'dashboard/helper/URLHelper';
import RoleManagement from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/role-management'),
      name: 'role_management_index',
      component: RoleManagement,
      meta: {
        permissions: ['administrator'],
      },
    },
  ],
};
